/**
 * Coordinator Service — Wedding coordinator dashboard & multi-wedding management
 */
import api from './api';

const coordinatorService = {
  getDashboard: () => api.get('/coordinator/dashboard').then(r => r.data),
  getWeddings: () => api.get('/coordinator/weddings').then(r => r.data),
  getCalendar: (params) => api.get('/coordinator/calendar', { params }).then(r => r.data),
  getWedding: (id) => api.get(`/coordinator/wedding/${id}`).then(r => r.data),
  getMultiOverview: () => api.get('/coordinator-multi/overview').then(r => r.data),
  getMultiConflicts: () => api.get('/coordinator-multi/conflicts').then(r => r.data),
  getMultiStaff: () => api.get('/coordinator-multi/staff').then(r => r.data),
  getWhiteLabel: () => api.get('/white-label/my').then(r => r.data),
  updateWhiteLabel: (data) => api.put('/white-label/my', data).then(r => r.data),

  // Marketplace profile (read by the public /coordinators page, edited
  // here by the coordinator themselves).
  getMyProfile:      () => api.get('/coordinator/profile').then(r => r.data),
  updateMyProfile:   (data) => api.put('/coordinator/profile', data).then(r => r.data),
  getMyAvailability: () => api.get('/coordinator/availability').then(r => r.data),
  updateMyAvailability: (entries) => api.put('/coordinator/availability', { entries }).then(r => r.data),
};

export default coordinatorService;
